import isNil from "lodash/isNil";
import { useNavigate, useParams } from "react-router-dom";
import { PROFILE_HOUSEHOLD_MEMBER_DATA_EDIT_PATH } from "../../../../constants/env";
import { useProductRequisites } from "../../../../legacy/hooks/use-product-requisites/useProductRequisites";
import { addMemberIdToPath } from "../../../../legacy/utils/add-member-id-to-path";
import { ConfirmExitContent } from "../../../../legacy/pages/ProfileData/modals/confirm-exit-content/confirm-exit-content";

export function ConfirmExitEditHouseholdMemberPersonalDataModal(): JSX.Element {
  const navigate = useNavigate();
  const { productRequisites } = useProductRequisites();
  const { memberId } = useParams<{ memberId?: string }>();

  function handleOnExit() {
    if (!memberId) return;

    const householdMemberEditPagePath = addMemberIdToPath(PROFILE_HOUSEHOLD_MEMBER_DATA_EDIT_PATH, memberId);
    const redirectPath = !isNil(productRequisites) ? productRequisites.productSurveyPath : householdMemberEditPagePath;

    navigate(redirectPath, { replace: true });
  }

  return <ConfirmExitContent onExit={handleOnExit} />;
}
